module.exports = __webpack_public_path__ + "img/12.fb271516.png";